// @flow
import React from 'react';
import { PLAN_ID_PP_1M, PLAN_ID_PP_12M, PLAN_ID_PPC_12M, PLAN_ID_PPC_1M } from '../../constants';
import PlansOverviewSubscribe from './PlansOverviewSubscribe';
import styles from './ConversionFormVisual.css';
import PlansOverviewSummary from './PlansOverviewSummary';
import ProceedToPayment from './ProceedToPayment';

type OwnProps = {
  selectedPlan: PLAN_ID_PP_1M | PLAN_ID_PP_12M | PLAN_ID_PPC_12M | PLAN_ID_PPC_1M,
  isTrialAvailable: boolean,
  relativeDiscount?: number,
  setSelectedPlan: Function,
  trialDurationDays: number,
  proceedToPayment: Function,
  isValentine26Campaign: boolean,
};

type Props = OwnProps;

const PlansOverviewStep = ({
  selectedPlan,
  isTrialAvailable,
  relativeDiscount,
  setSelectedPlan,
  trialDurationDays,
  proceedToPayment,
  isValentine26Campaign,
}: Props) => {
  return (
    <div className={styles.plansOverviewGrid} data-test="conversion-form.plans-overview-step-view">
      <PlansOverviewSummary
        isTrialAvailable={isTrialAvailable}
        trialDurationDays={trialDurationDays}
        isValentine26Campaign={isValentine26Campaign}
      />
      <PlansOverviewSubscribe
        setSelectedPlan={setSelectedPlan}
        selectedPlan={selectedPlan}
        relativeDiscount={relativeDiscount}
        isTrialAvailable={isTrialAvailable}
        trialDurationDays={trialDurationDays}
      />
      <ProceedToPayment
        proceedToPayment={proceedToPayment}
        selectedPlan={selectedPlan}
        isTrialAvailable={isTrialAvailable}
        trialDurationDays={trialDurationDays}
        isValentine26Campaign={isValentine26Campaign}
      />
    </div>
  );
};

export default PlansOverviewStep;
